import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { guestToken, resetPassword } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import errorHandler from "../../request/errorHandler";
import { toast } from "react-toastify";

export default function ResetPassword() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()

	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();

	const [steps, setSteps] = useState<any>({})


	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	useEffect(() => {
		const guest = localStorage.getItem('guest-token')
		if (!guest) {
			dispatch(guestToken())
		}
		clearErrors('NewPassword')
		clearErrors('Email')
		clearErrors('confirmPassword')
		clearErrors('OTP')
	}, [])


	const onFinish = async () => {
		if (steps?.NewPassword === steps?.confirmPassword) {
			await dispatch(resetPassword({
				loginData: {
					"Records": [
						{

							Email: steps?.Email,
							NewPassword: steps?.NewPassword,
							OTP: steps.otp,
							confirmPassword: steps?.confirmPassword
						}
					]
				}
			}))
		} else {
			toast.error(
				'NewPassword and Confirm Password must be same',
			);
		}
		const activeUser = storePersist.get('reset-pwd')
		switch (activeUser) {
			case 'rap':
				navigate('/auth/login/rap');
				break;
			case 'rap-agent':
				navigate('/auth/login/rap-agent');
				break;
			case 'management':
				navigate('/auth/login/management');
				break;
			case 'customer':
				navigate('/auth/login/customer');
				break;
		}


	};
	return (
		<>
			<form onSubmit={handleSubmit(onFinish)} >
				<div className="flex h-screen bg-[#F8F8F8]">
					<div className="container mx-auto px-4 ">
						<div className="flex content-center items-center justify-start h-full">
							<div className="w-1/2 h-max px-6">
								<div className="bg-white flex flex-col items-end justify-around h-full">
									<div className="flex flex-col justify-center w-full h-screen px-4 px-3">
										<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
											Reset Password
											<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
										</div>
										<div className="w-full my-5">
											<label
												className="block text-sm font-light mb-2" >
												Email Address *
											</label>
											<input
												type="text"
												{...register('Email', {
													required: true,
													pattern:
														/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
												})}
												className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
												placeholder="Email"
												onChange={(e) => handleSteps(e, 'Email')}
											/>
											{errors.Email && errors.Email.type === "required" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
											)}
											{errors.Email && errors.Email.type === "pattern" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
											)}

										</div>
										<div className="w-full my-5">
											<label
												className="block  text-black text-sm font-light mb-2"
											>
												New Password *
											</label>
											<input
												type="password"
												{...register('NewPassword', { required: true, maxLength: 15 })}
												className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
												placeholder="New Password"
												onChange={(e) => handleSteps(e, 'NewPassword')}
											/>
											{errors.NewPassword && errors.NewPassword.type === "required" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
											)}
											{errors.NewPassword && errors.NewPassword.type === "maxLength" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
											)}
										</div>
										<div className="w-full my-5">
											<label
												className="block  text-black text-sm font-light mb-2"
											>
												Confirm Password *
											</label>
											<input
												type="password"
												{...register('confirmPassword', { required: true, maxLength: 15 })}
												className="border-0 px-3 py-3  text-indigo-600    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
												placeholder="confirm Password"
												onChange={(e) => handleSteps(e, 'confirmPassword')}
											/>
											{errors.confirmPassword && errors.confirmPassword.type === "required" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
											)}
											{errors.confirmPassword && errors.confirmPassword.type === "maxLength" && (
												<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
											)}
										</div>

										<div className="w-full my-5">
											<label
												className="block  text-black text-sm font-light mb-2"
											>
												OTP *
											</label>
											<input
												className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
												type="number"
												placeholder="OTP"
												{...register('otp', {
													required: `OTP is required`,
												})}
												onChange={(e) => {
													handleSteps(e, 'otp');
												}}
											/>
										</div>

										<div className="text-center mt-6">
											<input type="submit"
												className="bg-black text-white text-xl p-2 w-full"
												value='Reset Password'
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="w-1/2 h-screen  flex justify-center items-center px-10">
								<img src={require('../../assets/img/cart.png')} />
							</div>
						</div>
					</div>
				</div >
			</form >
		</>
	);
}
